// src/modules/inventory/KitchenOrders.jsx
import React, { useState, useEffect } from 'react';
import {
  getKitchenOrders,
  completeOrder,
  getProductDetails,
} from '../../../../services/orderService';
import { updateStock } from '../../../../services/inventoryService';
import { notify } from '../../../Shared/toast';

function KitchenOrders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = () => {
      const kitchenOrders = getKitchenOrders();
      setOrders(kitchenOrders);
    };

    fetchOrders();
    const interval = setInterval(fetchOrders, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleCompleteOrder = async (orderId) => {
    try {
      const order = orders.find((o) => o.id === orderId);
      if (!order) return;

      // Update stock for each item
      await Promise.all(
        order.items.map(async (item) => {
          const product = getProductDetails(item.productId);
          if (product) {
            await updateStock(item.productId, -item.quantity);
          }
          return null;
        }),
      );

      // Mark order as completed
      completeOrder(orderId);
      setOrders((prev) => prev.filter((o) => o.id !== orderId));
    } catch (error) {
      notify.error('Failed to complete order:', error);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Kitchen Orders</h1>
      {orders.length === 0 ? (
        <p className="text-gray-500">No active orders in the kitchen</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {orders.map((order) => (
            <div
              key={`order-${order.id}`}
              className="border rounded-lg p-4 bg-white shadow-sm"
            >
              <div className="flex justify-between items-start">
                <h3 className="font-bold">
                  Order #
                  {order.id}
                </h3>
                <span className="text-sm text-gray-500">
                  {new Date(order.createdAt).toLocaleTimeString()}
                </span>
              </div>

              <ul className="my-3 space-y-2">
                {order.items.map((item) => {
                  const product = getProductDetails(item.productId);
                  return (
                    <li
                      key={`item-${order.id}-${item.productId}`}
                      className="text-sm"
                    >
                      <span className="font-medium">
                        {item.quantity}
                        x
                        {product?.name || 'Unknown Item'}
                      </span>
                      {item.kitchenNotes && (
                        <p className="text-xs text-gray-600 mt-1">
                          {item.kitchenNotes}
                        </p>
                      )}
                      {product?.stock !== undefined && product.stock < 10 && (
                        <p className="text-xs text-red-500 mt-1">
                          Low stock:
                          {' '}
                          {product.stock}
                          {' '}
                          remaining
                        </p>
                      )}
                    </li>
                  );
                })}
              </ul>

              <button
                type="button"
                onClick={() => handleCompleteOrder(order.id)}
                className="w-full bg-green-500 text-white py-2 rounded-md hover:bg-green-600 transition"
                aria-label={`Mark order ${order.id} as prepared`}
              >
                Mark as Prepared
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default KitchenOrders;
